const DISCIPLINE_GETTERS = {
  getDisciplineList: (state) => state.disciplines,
  getLoadingState: (state) => state.status.loading,
  getButtonLoadingState: (state) => state.buttonLoading,
};

export default DISCIPLINE_GETTERS;
